import React from "react";
import SlickSlider from "./SlickSlider";
import MentorTalkCard from "./MentorTalkCard";
import $ from "jquery";
import { doAnimations } from "../../lib/helpers";
import cn from "classnames";

const MentorTalk = () => {
  const slick_settings = {
    dots: true,
    infinite: true, // Ensures the slider loops continuously
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000, // Adjust the speed of autoplay if needed
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    beforeChange: function (currentSlide, nextSlide) {
      var $animatingElements = $(
        '.single-slider[data-slick-index="' + nextSlide + '"]'
      ).find("[data-animation]");
      doAnimations($animatingElements);
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
        },
      },
    ],
  };
  

  const slider_items = [
    {
      title: "Babji Neelam",
      designation: "Founder & CEO - Technical Hub",
      desc: `Sai Chandu's deep knowledge of React Native, full-stack development, networking, and cloud technologies, combined with his ability to simplify complex topics, makes him an invaluable asset to any tech team.`,
      src: "/Images/Mentors/BabjiSir.jpeg",
    },
    {
      title: "Durga Sai Prasad",
      designation: "FSD Mentor - Technical Hub",
      desc: `Sai Chandu's full-stack expertise was evident in projects like the LateComers website. His technical skills and problem-solving mindset make him a standout professional in the field.`,
      src: "/Images/Mentors/DSP.jpg",
    },
    {
      title: "Hanumanthu",
      designation: "Developer - Technical Hub",
      desc: `Sai Chandu possesses a deep understanding of both frontend and backend technologies, paired with a strong analytical mindset, making him a versatile and dependable developer in web and mobile application development.`,
      src: "/Images/Mentors/Hanumanthu.png",
    },
    {
      title: "Kiran Kumar",
      designation: "Communication Mentor - Technical Hub",
      desc:`Sai Chandu demonstrates exceptional communication proficiency, effectively conveying complex ideas, fostering collaboration, and delivering presentations with clarity and poise.`,
      src: "/Images/Mentors/Kiran Kumar.png",
    },
  ];
  
  return (
    <section className="testimonial-area " style={{backgroundColor : "#292930", paddingTop : 20, paddingBottom : 20}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-60">
              <span className="sub-title">Testimonials</span>
              <h2 className="title" style={{color : "white"}}>What My Mentors Say's About Me</h2>
            </div>
          </div>
        </div>

        <div className="testimonial-item-wrap">
          <div className="row testimonial-active">
            <SlickSlider settings={slick_settings}>
              {slider_items.map((x, index) => (
                <div
                  key={index}
                  className={cn(
                    "col-lg-2 col-md-4 col-sm-6 single-slider",
                    index % 2 === 0 && "testimonial-item-wrap-item-even"
                  )}
                  style={{width: "200px"}}
                >
                  <MentorTalkCard item={x} />
                </div>
              ))}
            </SlickSlider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MentorTalk;
